uniform float uTime;
uniform vec3 uMouseWorldPosition; // World space position of the mouse
uniform float uEffectRadius; // Radius in world units

varying vec2 vUv;
varying float vMouseEffect;

void main() {
    vUv = uv;
    
    // Get the world position of this vertex
    vec4 worldPosition = modelMatrix * vec4(position, 1.0);
    
    // Calculate distance from mouse position to this vertex in world space
    float distanceToMouse = distance(uMouseWorldPosition.xy, worldPosition.xy);
    
    // Create a falloff effect based on world space distance
    vMouseEffect = 1.0 - smoothstep(0.0, uEffectRadius, distanceToMouse);
    
    // Apply smoother falloff
    vMouseEffect = pow(vMouseEffect, 1.5);
    
    // Apply z-axis distortion based on mouse effect
    vec3 newPosition = position;
    newPosition.z += vMouseEffect * 0.8;
    
    // Calculate final position
    gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);
}